<template>
  <div>
    <mu-card-header titleClass="boldTitle  largeTitle" :title="title" :subTitle="subTitle"></mu-card-header>
    <mu-card-text>
      <mu-paper>
        <mu-auto-complete
          class="inputInPaper"
          icon="search"
          :underlineShow="false"
          :scroller="scroller"
          :inputClass="conditionSearchClass"
          :openOnFocus="!conditionSearching"
          :fullWidth="true"
          :hintText="$t('message.searchText')"
          v-model="conditionSearchValue"
          :maxSearchResults="10"
          :dataSource="conditionDataSource"
          :dataSourceConfig="conditionDataSourceConfig"
          :maxHeight="250"
          @change="handleConditionSelected"
          filter="noFilter"/>
      </mu-paper>
    </mu-card-text>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 136px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>
    <div v-if="conditions.length === 0 && !isLoading" align="center">
      <div class="dashedBorder"></div>
      <img width="80" src="static/moods/content.svg">
      <br/>
      <h2 style="margin-bottom: 4px">{{ $t('message.conditionsPreferencesEmpty') }}</h2>
      {{ $t('message.conditionsPreferencesHelpText') }}
    </div>
    <mu-list>
      <mu-list-item
        disableRipple
        v-for="item, index in conditions"
        :key="'cd-' + index"
        v-bind:class="{odd: index % 2 === 0}"
        :title="item.condition_label"
      >
        <mu-icon-button
          @click.native="deleteCondition(item)"
          icon="delete"
          slot="right"
        ></mu-icon-button>
      </mu-list-item>
    </mu-list>
    <mu-card-text>
      <mu-raised-button

        class="large"
        :disabled="conditions.length === 0 || isSaving"
        :label="isSaving ? $t('message.updatingText'): $t('message.updateText')"
        @click.native="submitForm()"
        secondary
        fullWidth
      ></mu-raised-button>
    </mu-card-text>
  </div>
</template>
<script>

  import AccountApi from '../../api/Account'
  import UserApi from '../../api/User'
  import ConditionSearchMixin from '../../mixins/ConditionSearchMixin'
  import ScrollerMixin from '../../mixins/ScrollerMixin'

  export default {
    mixins: [ConditionSearchMixin, ScrollerMixin],
    name: 'settings-conditions',
    data() {
      return {
        title: this.$t('message.conditionsPreferencesTitle'),
        subTitle: this.$t('message.conditionsPreferencesSubTitle'),
        isSaving: false,
        isLoading: true,
        conditions: [],
        model: {}
      }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/conditions');
      UserApi.getUserConditions().then(function (response) {
        self.conditions = response.data;
        self.isLoading = false;
      })
    },
    methods: {
      submitForm() {
        let self = this;
        self.isSaving = true;
        AccountApi.putUserConditions(self.conditions)
          .then(function (response) {
            self.isSaving = false;
            self.conditions = response.data;
            self.$toastr.success(self.$t('message.updatedText'));
          })
      },
      deleteCondition(item) {
        let self = this;
        let index = self.conditions.indexOf(item);
        self.conditions.splice(index, 1);
        AccountApi.putUserConditions(self.conditions)
          .then(function (response) {
            self.isSaving = false;
            self.conditions = response.data;
          })
      }
    }
  }
</script>
<style>
  .inputInPaper {
    margin-top: 4px;
    margin-bottom: -4px;
    padding-bottom: 0px;
  }

  .inputInPaper .mu-text-field-content {
    padding-bottom: 0;
    padding-top: 0;
    margin-top: 8px;
    margin-left: -4px;
  }

  .conSearchInput {
    padding-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// Conditions.vue?f5efc8c2